// Saque aniversário Resultado

import * as React from "react";
import { Footer, NavBar, ColdSimulationResults, FAQ } from "../../components";
import { Box, Grid, GridItem, ResponsiveLayout, skinVars, useScreenSize } from "@telefonica/mistica";
import { observer, useLocalObservable } from "mobx-react-lite";
import { Store } from "./store";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { useAnalytics } from "../../hooks/useAnalytics";
import { strings } from "../../localization";
import { Box as ChakraBox } from "@chakra-ui/react";
import { colors } from "../../theme/colors";
import { useNavigateCustom } from "../../hooks";

const SimulatorResume: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { preSimulationStore } = useGlobalStore();
	const store = useLocalObservable(
		() => new Store(preSimulationStore.balance.value, preSimulationStore.birthMonth.value),
	);
	const {
		components: { coldSimulationResults },
	} = strings;
	const { updatePageView, addAnalyticEvent } = useAnalytics();

	const action = (): void => {
		addAnalyticEvent(
			{
				component: "button",
				action: "click",
				description: coldSimulationResults.labelButton,
				step: "lp-antecipacao-fgts",
				value: "",
			},
			{ applySanitize: true },
		);

		navigation("/login");
	};

	React.useEffect(() => {
		store.fetchPreSimulation();

		updatePageView({
			pagePath: "/fgts/simulação-saque-aniversario/resultado",
			isNewPageviewFormat: true,
		});
	}, [store]);

	const { isMobile } = useScreenSize();

	return (
		<>
			<NavBar />
			<ResponsiveLayout backgroundColor={skinVars.colors.backgroundAlternative}>
				<Grid columns={{ maxSize: 700 }} justifyContent="center">
					<Box
						paddingTop={isMobile ? 32 : 40}
						paddingBottom={isMobile ? 0 : 48}
						className="cold-simulation-card-new-layout "
					>
						<Grid columns={{ maxSize: 600, minSize: 340 }} gap={56} justifyContent="center">
							<GridItem>
								<ColdSimulationResults
									amountAvailable={store.preSimulation.value?.availableAmount || 0}
									FGTSBalance={preSimulationStore.balance.value}
									birthMonth={preSimulationStore.birthMonth.value}
									action={action}
									isLoading={store.loader.isLoading}
								/>
							</GridItem>
						</Grid>
					</Box>
				</Grid>
			</ResponsiveLayout>
			<ChakraBox pt={{ base: "40px", lg: "0px" }} bg={colors.white[550]}>
				<FAQ backgroundColor={skinVars.colors.backgroundAlternative} analyticStepName="lp-antecipacao-fgts" />
			</ChakraBox>
			<Footer />
		</>
	);
});

export default SimulatorResume;
